// extracted by mini-css-extract-plugin
export default {"link_download":"styles_link_download__c2qHW","column_button":"styles_column_button__MMaVd","stosks_column":"styles_stosks_column__yA6OV","text_time":"styles_text_time__u3rpz"};